// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3mrlC","large":"styles_large__3O2Ti"};